import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import axios from "axios";
import dayjs, { Dayjs } from 'dayjs';
import { Alert, Form, Modal } from "antd";
import { axiosErrorHandler } from "../../../../swzutils";
import DateRangePicker from "../../components/DateRangePicker";
const ConsignmentPickupTimeModal = (props) => {
    const formRef = React.useRef(null);
    const [stateSaving, setStateSaving] = React.useState(false);
    const [stateErrorMessage, setStateErrorMessage] = React.useState(null);
    useEffect(() => {
        const { consignment } = props;
        if (consignment?.pickupFrom && consignment.pickupTo) {
            formRef.current?.setFieldsValue({
                pickupDateRange: [
                    dayjs(consignment.pickupFrom),
                    dayjs(consignment.pickupTo)
                ]
            });
        }
        else {
            formRef.current?.setFieldsValue({
                pickupDateRange: [null, null]
            });
        }
        setStateErrorMessage(null);
    }, [props.consignment?.pickupFrom, props.consignment?.pickupTo]);
    const patchConsignmentPickupTime = (fromDays, toDayjs) => {
        setStateSaving(true);
        const request = {
            pickupFrom: fromDays ? fromDays.toISOString() : null,
            pickupTo: toDayjs ? toDayjs.toISOString() : null,
            clearPickupDate: fromDays && toDayjs ? null : true,
            version: props.consignment?.version
        };
        axios.patch(`/admin/v1/consignments/${props.consignment.id}`, request)
            .then(response => {
            props.onUpdated(response.data);
        })
            .catch(error => {
            axiosErrorHandler(error, errorMessage => {
                setStateErrorMessage(errorMessage);
            });
        })
            .finally(() => {
            setStateSaving(false);
        });
    };
    const handleFinish = (values) => {
        const from = values?.pickupDateRange?.[0];
        const to = values?.pickupDateRange?.[1];
        patchConsignmentPickupTime(from, to);
    };
    const submitForm = () => {
        formRef.current.submit();
    };
    return (_jsxs(Modal, { open: props.open, onCancel: props.onCancel, onOk: submitForm, confirmLoading: stateSaving, title: "Pickup Time", destroyOnHidden: true, children: [_jsx(Form, { layout: "vertical", ref: formRef, onFinish: handleFinish, children: _jsx(Form.Item, { name: "pickupDateRange", label: "Pickup Date and Time", initialValue: (props.consignment && props.consignment.pickupFrom && props.consignment.pickupTo)
                        ? [dayjs(props.consignment.pickupFrom), dayjs(props.consignment.pickupTo)]
                        : [], children: _jsx(DateRangePicker, { allowClear: true }) }) }), stateErrorMessage &&
                _jsx("div", { style: { marginTop: "20px" }, children: _jsx(Alert, { type: "error", title: stateErrorMessage, banner: true }) })] }));
};
export default ConsignmentPickupTimeModal;
